// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 111 ? "my-worker" : chunkId) + "." + {"111":"8cc2909e","929":"16d67b23"}[chunkId] + ".chunk.js";
};